import React from 'react'
import { Route, Routes, HashRouter, Navigate } from 'react-router-dom'
import Main from './pages/main'
import Flux from './pages/flux'
import PrivacyPolicy from './pages/privacy-policy'
import CCPANotice from './pages/ccpa-notice'
import TACOFPlusService from './pages/tac-plus'
import TOSLicense from './pages/tos-license'

function App(props) {
  return (
    <HashRouter>
      <Routes>
        <Route path="/flux" element={<Flux />} />
        <Route path="/PrivacyPolicy" element={<PrivacyPolicy />} />
        <Route path="/CCPANotice" element={<CCPANotice />} />
        <Route path="/TACOFPlusService" element={<TACOFPlusService />} />
        <Route path="/TOSLiAServiceFFluxApp" element={<TOSLicense />} />
        <Route path="/doc/:lang" element={<Main />} />
        <Route path="*" element={<Navigate to="/doc/eu" replace />} />
      </Routes>
    </HashRouter>
  )
}

export default App
